import { DEFAULT_LANGUAGE } from 'constants/localization';

import { getLocalizationFromAvailable } from 'helpers/localization';

import bg_desktop from './assets/bg_desktop.webp';
import bg_mobile from './assets/bg_mobile.webp';
import cs_desktop from './assets/cs_desktop.webp';
import cs_mobile from './assets/cs_mobile.webp';
import da_desktop from './assets/da_desktop.webp';
import da_mobile from './assets/da_mobile.webp';
import de_desktop from './assets/de_desktop.webp';
import de_mobile from './assets/de_mobile.webp';
import el_desktop from './assets/el_desktop.webp';
import el_mobile from './assets/el_mobile.webp';
import en_desktop from './assets/en_desktop.webp';
import en_mobile from './assets/en_mobile.webp';
import es_desktop from './assets/es_desktop.webp';
import es_mobile from './assets/es_mobile.webp';
import et_desktop from './assets/et_desktop.webp';
import et_mobile from './assets/et_mobile.webp';
import fi_desktop from './assets/fi_desktop.webp';
import fi_mobile from './assets/fi_mobile.webp';
import fr_desktop from './assets/fr_desktop.webp';
import fr_mobile from './assets/fr_mobile.webp';
import hr_desktop from './assets/hr_desktop.webp';
import hr_mobile from './assets/hr_mobile.webp';
import hu_desktop from './assets/hu_desktop.webp';
import hu_mobile from './assets/hu_mobile.webp';
import it_desktop from './assets/it_desktop.webp';
import it_mobile from './assets/it_mobile.webp';
import ja_desktop from './assets/ja_desktop.webp';
import ja_mobile from './assets/ja_mobile.webp';
import ko_desktop from './assets/ko_desktop.webp';
import ko_mobile from './assets/ko_mobile.webp';
import lt_desktop from './assets/lt_desktop.webp';
import lt_mobile from './assets/lt_mobile.webp';
import lv_desktop from './assets/lv_desktop.webp';
import lv_mobile from './assets/lv_mobile.webp';
import no_desktop from './assets/no_desktop.webp';
import no_mobile from './assets/no_mobile.webp';
import pl_desktop from './assets/pl_desktop.webp';
import pl_mobile from './assets/pl_mobile.webp';
import pt_desktop from './assets/pt_desktop.webp';
import pt_mobile from './assets/pt_mobile.webp';
import ro_desktop from './assets/ro_desktop.webp';
import ro_mobile from './assets/ro_mobile.webp';
import sk_desktop from './assets/sk_desktop.webp';
import sk_mobile from './assets/sk_mobile.webp';
import sl_desktop from './assets/sl_desktop.webp';
import sl_mobile from './assets/sl_mobile.webp';
import sv_desktop from './assets/sv_desktop.webp';
import sv_mobile from './assets/sv_mobile.webp';
import tr_desktop from './assets/tr_desktop.webp';
import tr_mobile from './assets/tr_mobile.webp';

const IMAGES: Record<string, { desktop: string; mobile: string }> = {
    bg: { desktop: bg_desktop, mobile: bg_mobile },
    cs: { desktop: cs_desktop, mobile: cs_mobile },
    da: { desktop: da_desktop, mobile: da_mobile },
    de: { desktop: de_desktop, mobile: de_mobile },
    el: { desktop: el_desktop, mobile: el_mobile },
    en: { desktop: en_desktop, mobile: en_mobile },
    es: { desktop: es_desktop, mobile: es_mobile },
    et: { desktop: et_desktop, mobile: et_mobile },
    fi: { desktop: fi_desktop, mobile: fi_mobile },
    fr: { desktop: fr_desktop, mobile: fr_mobile },
    hr: { desktop: hr_desktop, mobile: hr_mobile },
    hu: { desktop: hu_desktop, mobile: hu_mobile },
    it: { desktop: it_desktop, mobile: it_mobile },
    ja: { desktop: ja_desktop, mobile: ja_mobile },
    ko: { desktop: ko_desktop, mobile: ko_mobile },
    lt: { desktop: lt_desktop, mobile: lt_mobile },
    lv: { desktop: lv_desktop, mobile: lv_mobile },
    no: { desktop: no_desktop, mobile: no_mobile },
    pl: { desktop: pl_desktop, mobile: pl_mobile },
    pt: { desktop: pt_desktop, mobile: pt_mobile },
    ro: { desktop: ro_desktop, mobile: ro_mobile },
    sk: { desktop: sk_desktop, mobile: sk_mobile },
    sl: { desktop: sl_desktop, mobile: sl_mobile },
    sv: { desktop: sv_desktop, mobile: sv_mobile },
    tr: { desktop: tr_desktop, mobile: tr_mobile },
};

export const useGetImages = (): { desktop: string; mobile: string } => {
    const locale = getLocalizationFromAvailable();

    return IMAGES[locale] ?? IMAGES[DEFAULT_LANGUAGE];
};
